import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useAppointments } from '@features/appointments';
import { AppointmentsList } from './AppointmentsList';

interface ScheduleListViewProps {
  onAppointmentDelete?: (appointmentId: string, seriesId?: string) => Promise<void>;
}

export const ScheduleListView: React.FC<ScheduleListViewProps> = ({ onAppointmentDelete }) => {
  // Get all data from appointments hook
  const { appointments, isLoading, isBackgroundLoading } = useAppointments();

  return (
    <Box sx={{ pt: 3, pb: 4, px: 4, position: 'relative' }}>
      {/* Background loading indicator */}
      {isBackgroundLoading && (
        <Box
          sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            zIndex: 2,
            p: 1.5,
            borderRadius: 1,
            bgcolor: 'background.paper',
            boxShadow: 1,
            display: 'flex',
            alignItems: 'center',
            border: '1px solid',
            borderColor: 'primary.light',
          }}
        >
          <CircularProgress size={16} sx={{ color: 'primary.main' }} />
        </Box>
      )}

      {/* Encounters List */}
      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
          <CircularProgress />
        </Box>
      ) : appointments.length === 0 ? (
        <Box sx={{ textAlign: 'center', p: 4 }}>
          <Typography variant="h6" color="text.secondary">
            No appointments found
          </Typography>
        </Box>
      ) : (
        <AppointmentsList
          appointments={appointments}
          onCancel={onAppointmentDelete}
          showDateHeaders={true}
          analyticsSource="schedule"
          defaultExpanded="first"
        />
      )}
    </Box>
  );
};

export default ScheduleListView;
